'use client';

import { useState } from 'react';

import { getCookie } from './get-cookie';

export const useClientCookie = (cookieNamePrefix: string) => {
  const [cookieValue, setCookieValue] = useState(getCookie(cookieNamePrefix));

  return {
    cookieValue,
    refreshCookieValue: () => setCookieValue(getCookie(cookieNamePrefix)),
  };
};
